import { Box, Button, Group, Paper, Stack } from '@mantine/core';
import { IconLogout } from '@tabler/icons-react';
import { tokens } from '../theme';
import { CreateOrganisationForm, type CreateOrganisationFormProps } from '../components/CreateOrganisationForm';

// Standalone branded layout outside the Hub shell, so it carries its own sign-out
// affordance. Presentational only: no hooks, no SDK.
export type WelcomeViewProps = {
  onSignOut: () => void;
  createOrganisation: CreateOrganisationFormProps;
};

export function WelcomeView({ onSignOut, createOrganisation }: Readonly<WelcomeViewProps>) {
  return (
    <Box style={{ minHeight: '100vh', background: tokens.navy, display: 'flex', flexDirection: 'column' }}>
      <Box style={{ padding: '24px 32px' }}>
        <img src="/cloudhouse-logo.png" alt="Cloudhouse" style={{ height: 30, width: 'auto', objectFit: 'contain' }} />
      </Box>
      <Box style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 32px 48px' }}>
        <Paper style={{
          width: '100%', maxWidth: 460, background: tokens.navyDeep,
          border: `1px solid ${tokens.navyBorder}`, borderRadius: 18, padding: 40,
          boxShadow: '0 24px 56px rgba(0, 0, 0, 0.5)',
        }}>
          <Stack gap={20}>
            <CreateOrganisationForm {...createOrganisation} />
            <Group justify="flex-end">
              <Button
                variant="subtle"
                leftSection={<IconLogout size={16} stroke={1.8} />}
                styles={{ root: { color: tokens.textMuted } }}
                onClick={onSignOut}
              >
                Sign out
              </Button>
            </Group>
          </Stack>
        </Paper>
      </Box>
    </Box>
  );
}
